import { columnTextGrid } from '@mage-ui/styled-system/recipes';

//ColumnsTextBlock
export const ColumnTextGrid = ({ children, title, ...props }) => {
  return (
    <div className={columnTextGrid()} {...props}>
      {children}
    </div>
  );
};
